import { Link } from "react-router-dom";
import styled from "styled-components";
import { minMedium, shade0 } from "@songtradr-one/components-frontend";

// TEXT

// STYLES
export const LogoLink = styled(Link)<{ $disabled?: boolean }>`
  pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};
  padding: 0 1rem;
  height: auto;
  display: flex;
  align-items: center;
  width: max-content;

  &:focus-visible {
    box-shadow: inset 0 0 0 1px ${shade0};
  }
`;

export const OrgName = styled(LogoLink)`
  color: ${shade0};
  text-decoration: none;
  font-size: 1.25rem;
  font-weight: 800;
  text-transform: uppercase;
  transform: scaleX(1.4);

  transition: scale 0.3s ease-in-out;

  &:hover {
    scale: 1.05;
  }
`;

export const OrgLogo = styled.img`
  max-width: 100%;
  max-height: 1rem;
  object-fit: contain;

  @media ${minMedium} {
    max-height: 2rem;
  }
`;

// DATA

// TYPES

// CONSTANTS

// FUNCTIONS

// ASSETS
